<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Matrículas</span>
      <span class="titulo-contexto">
        Vincule catequizandos a uma turma. O ano da matrícula é o da própria turma.
      </span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="campo-filtro campo-filtro--wide">
        <app-autocomplete
          [rotulo]="turmaSelecionada ? 'Turma · ano ' + anoTurma : 'Turma'"
          placeholder="Digite parte do nome ou o ano"
          [opcoes]="opcoesTurma"
          [selecionadoId]="turmaSelecionada"
          (selecionadoIdChange)="onTurmaChange($event)"
          [buscaNoServidor]="true"
          [carregando]="carregandoTurmas"
          (buscar)="carregarTurmas($event)"
          msgSemResultado="Nenhuma turma encontrada"
        ></app-autocomplete>
      </div>

      <div class="campo-filtro campo-filtro--wide">
        <app-autocomplete
          rotulo="Buscar pessoa"
          placeholder="Nome ou CPF"
          [opcoes]="opcoesPessoa"
          [selecionadoId]="pessoaSelecionadaId"
          (selecionadoIdChange)="onPessoaChange($event)"
          [carregando]="buscandoPessoas"
          [desabilitado]="!turmaSelecionada"
          msgSemResultado="Nenhuma pessoa sem turma neste ano"
        ></app-autocomplete>
      </div>

      <div class="campo-filtro--acoes">
        <button
          nbButton
          status="success"
          size="medium"
          type="button"
          [disabled]="!pessoaSelecionada"
          (click)="adicionarPessoa()"
        >
          <nb-icon pack="eva" icon="person-add-outline"></nb-icon>
          <span>Adicionar</span>
        </button>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregandoPessoas"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="matriculas.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="pessoaNome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="pessoaCpf" rotuloAcessivel="CPF" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">CPF</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let matricula of matriculasExibidas">
            <td data-label="Nome">{{ matricula.pessoaNome }}</td>
            <td data-label="CPF">{{ matricula.pessoaCpf || '—' }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="info"
                  class="btn-acao"
                  (click)="transferirPessoa(matricula)"
                  title="Transferir de turma"
                  aria-label="Transferir de turma"
                >
                  <nb-icon pack="eva" icon="swap-outline"></nb-icon>
                </button>
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="danger"
                  class="btn-acao"
                  (click)="removerPessoa(matricula)"
                  title="Remover da turma"
                  aria-label="Remover da turma"
                >
                  <nb-icon pack="eva" icon="person-delete-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="vazio" *ngIf="!carregandoPessoas && !turmaSelecionada">Selecione uma turma para ver as matrículas.</p>
    <app-lista-vazia
      *ngIf="!carregandoPessoas && turmaSelecionada && !matriculas.length"
      icone="people-outline"
      mensagem="Nenhum catequizando matriculado nesta turma. Use a busca acima para matricular."
    ></app-lista-vazia>
  </nb-card-body>
</nb-card>
